import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  CanActivate
} from '@angular/router';
import { Observable } from 'rxjs';
import {BASE_URL_PATH, TABLE_LOCATION_KEY} from '../constants';

@Injectable({
  providedIn: 'root',
})
export class TableRedirectService implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const merchantId = route.paramMap.get('merchantId');
    const locationId = route.paramMap.get('locationId');
    const tableNumber = route.paramMap.get('tableNumber');
    sessionStorage.setItem(TABLE_LOCATION_KEY, locationId);
    const redirectUrl =`${BASE_URL_PATH}/${merchantId}/locations/${locationId}?tableNumber=${tableNumber}`;
    return this.router.parseUrl(redirectUrl);
  }
}
